import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-122" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-123" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-124" data-mp="1mmqz075erpqa">
          <span aria-hidden="true" data-id="element-125" data-mp="tyv5tcf1sfy9">🏆 </span>Offerta di Lancio
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-126" data-mp="tz3fkvfvj558">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-127" data-mp="p24pcnzbzicb">
            Pacchetto DANCE PRONTA™
          </span>

          <dl data-id="element-128" data-mp="2fbxzhbofape6">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-129" data-mp="2fad3dhmgmye7">
                <dt className="text-ink/80" data-id="element-130" data-mp="pj5uqoeuwie0">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-131" data-mp="ujbqogs5sr1w">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-132" data-mp="zioaesnqhi09">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-133" data-mp="13jq9n9hnhu28">
                Valore Totale:
              </dt>
              <dd className="font-bold text-amber-700 line-through" data-id="element-134" data-mp="6uiqu98f1z20">193€</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-135" data-mp="btvir8e59wbg">
            Solo per oggi
          </p>
          <p className="flex items-baseline justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-136" data-mp="fskyv8qkhrys">
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-137" data-mp="3k8m1cvcqk533">
              19€
            </span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-138" data-mp="3o95wxuhnv0n4">
            <span aria-hidden="true" data-id="element-139" data-mp="vez3ewszbp4k">💳 </span>Pagamento unico. Accesso a vita.
            Nessun abbonamento.
          </p>

          <CtaButton className="mt-4 w-full" label="Scarica tutto ora per 19€" data-id="element-140" data-mp="qg4i9o7jhoha" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-141" data-mp="154ikbwx4t8ws">
            Download Immediato · Pagamento Unico · Accesso a Vita · Garanzia 7
            Giorni
          </p>
        </div>
      </div>
    </section>;
}